const size = 150;

async function PrintCharacter(signatureImage, text) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      const c = document.createElement("canvas");
      const ctx = c.getContext("2d");

      if (ctx) {
        c.width = size;
        c.height = size;
        ctx.fillStyle = "transparent";
        ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(img, 0, 0, size, size);
        const dataUri = c.toDataURL("image/png");

        console.log(
          `%c . %c${text}`,
          `
            font-size: 1px;
            padding: ${Math.floor(size / 2)}px ${Math.floor(size / 2)}px;
            background-image: url(${dataUri});
            background-repeat: no-repeat;
            background-size: ${size}px ${size}px;
            color: transparent;
          `,
          `
            color: #66e5ff;
            font-size: 24px;
            font-weight: bold;
            text-shadow: -1px 1px 0 #000, 1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
          `
        );
      }

      resolve();
    };

    img.src = signatureImage;
  });
}

async function Main() {
  await PrintCharacter(
    "https://scripts.tundrashark.com/tundrashark.webp",
    "Programmed by Tundra Shark\nhttps://bsky.app/profile/tundrashark.com\nhttps://x.com/TundraSharks\nhttps://tundrashark.com"
  );
}

Main();
